(() => {
	$(() => {
		// Base code used on all pages
		base();

		// Homepage code
		homepage();

		// Subpage code
		subpage();

		// Single article code
		singleArticle();
	});
})();
